import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode:'history',
  base:"/cl/",
  routes: [
    {
      path: '/',
      name: 'home',
      component: ()=>import('@/view/home.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js